/**
 * Polling-cadence helper for the discovery-intake extraction phase.
 *
 * Background: the long-extraction path (530pp SROGs PDF, see
 * `plan-luminous-honking-origami.md` Wave 2 Correction F) can now run
 * 25 minutes when the extraction worker moves to Fargate. The legacy
 * fixed 2-second polling interval that worked for ~60-120s extractions
 * would issue ~750 polls per 25-min job per open tab. Backing off as
 * the job ages drops that to ~80 polls per job with no user-visible
 * latency change for the typical (sub-minute) case.
 *
 * Curve (from plan Wave 2 Correction F):
 *   elapsed <  1m  → 2s
 *   elapsed <  5m  → 5s
 *   elapsed < 15m  → 15s
 *   elapsed ≥ 15m  → 30s
 *
 * Plain TS — no React dependency — so the polling loop can read it
 * from any timer-driven context. Unit-tested at the tier boundaries
 * in `intakePollingCadence.test.ts`.
 */

const ONE_MINUTE_MS = 60_000;
const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;
const FIFTEEN_MINUTES_MS = 15 * ONE_MINUTE_MS;

export function nextPollInterval(elapsedMs: number): number {
  if (elapsedMs < ONE_MINUTE_MS) return 2_000;
  if (elapsedMs < FIVE_MINUTES_MS) return 5_000;
  if (elapsedMs < FIFTEEN_MINUTES_MS) return 15_000;
  return 30_000;
}
